import lastest from './lastest';

const stopAlerts = {
  lastest
};

export default stopAlerts;
